import "@/App.css";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Sobre } from "./components/Sobre";
import { Transparencia } from "./components/Transparencia";
import { Galeria } from "./components/Galeria";
import { Contato } from "./components/Contato";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";

function App() {
  return (
    <div className="App bg-[#0F0F11] min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Sobre />
        <Transparencia />
        <Galeria />
        <Contato />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
